import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useGDPR from './hooks/use-gdpr';

import Login from './pages/login';

export const UnauthenticatedApp: React.FC = () => {
  const { firstTimeLaunch } = useGDPR();

  if (firstTimeLaunch) return null;

  return (
    <Routes>
      <Route element={<Login />} path="/login" />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default UnauthenticatedApp;
